import { render, staticRenderFns } from "./TestingResults.vue?vue&type=template&id=77132702"
import script from "./TestingResults.vue?vue&type=script&lang=js"
export * from "./TestingResults.vue?vue&type=script&lang=js"
import style0 from "./TestingResults.vue?vue&type=style&index=0&id=77132702&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports